<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Project Order Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/project-orders-summary">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <!-- <v-row>
          <v-col cols="12" md="12">
            <v-btn text @click="generateInvoice" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
              Invoice
            </v-btn>

            <v-btn text @click="generateDelivery" color="primary">
              <v-icon color="black" left>mdi-file-pdf-box</v-icon>Generate
              Delivery
            </v-btn>
          </v-col>
        </v-row> -->

        <v-divider></v-divider>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" md="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Order#:</td>
                    <td>{{ Invoice && Invoice.DocNum}}</td>
                  </tr>
                  <tr>
                    <td>Project:</td>
                    <td>{{ Invoice && Invoice.Project.name}}</td>
                  </tr>
                  <tr>
                    <td>Total Bill:</td>
                    <td>{{ Invoice && Invoice.DocTotal | currency}}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

        </v-row>

        <v-divider></v-divider>

        <v-row dense id="po" class="text--primary subtitle-2 mt-2">
          <v-col cols="12">
            <v-data-table
              light
              :mobile-breakpoint="0"
              :items-per-page="pageItems"
              :headers="headers"
              :items="SaleRows"
              item-key="id"
              hide-default-footer
            >
              <template v-slot:item.Name="{ item }">
                <span style="width: 200px">{{ item.product.Name }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                {{
                item.Quantity
                }}
              </template>

              <template v-slot:item.Price="{ item }">
                <span v-if="item.Price">{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.DiscSum="{ item }">
                {{
                item.DiscSum
                }}
              </template>

              <template v-slot:item.LineTotal="{ item }">
                {{
                item.LineTotal | currency
                }}
              </template>
            </v-data-table>
          </v-col>

        </v-row>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>
  
  
  <script>
import { http, host } from "@/common/index";
export default {
  props: {
    initial: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    record: {},
    loader: false,
    pageItems: 100,
    Invoice: {},
    TotalPaid: 0,
    Balance: 0,
    OutsourcedProducts: [],
    SaleRows: [],
    Payments: [],
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "Unit" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Unit", value: "Unit" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" }
    ]
  }),
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true
    }
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      this.$store
        .dispatch("get", `/sales-invoice/${val}`)
        .then(res => {
          console.log(res, " invoice response");
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
            const val = res.ResponseData;
            self.Invoice = val.Invoice;
            self.TotalPaid = val.TotalPaid;
            self.Balance = val.Balance;
            self.SaleRows = val.SaleRows;
            self.OutsourcedProducts = val.OutsourcedProducts;
            self.Payments = val.Payments;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    init(val) {
      this.Invoice = val.Invoice;
      this.TotalPaid = val.TotalPaid;
      this.Balance = val.Balance;
      this.SaleRows = val.SaleRows;
      this.OutsourcedProducts = val.OutsourcedProducts;
      this.Payments = val.Payments;
    },
    generateReceipt() {},
    generateInvoice() {
      var url = "/print-sale-invoice-document/14/" + this.Invoice.id;
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    generateDelivery() {
      var url = "/print-sale-delivery-document/10/" + this.Invoice.id;
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    setDate(date) {
      this.record.DocDate = date;
    }
  },
  created() {}
};
</script>
  
  <style  scoped>
/* .v-text-field__details {
    display: none !important;
  } */
</style>